import { lazy } from "react";

export { TASKS_CONTROL_PATH } from "./path";
export const TasksControl = lazy(() => import("./page"));
